module.exports = __webpack_public_path__ + "static/media/30years.619c9df0.png";